import type { TreeRelation } from '@halo/utils';
import { genMenu } from '@/scripts/router';
import type { RouteItem } from '@/scripts/router/types';
import Paths from './paths';
import { routeMap as map } from './routeMap';

export const menuRelation: TreeRelation<RouteItem> = [
  map[Paths.CALLS],
  map[Paths.MESSAGES],
  map[Paths.FEEDS],
  map[Paths.SHORTS],
  map[Paths.WALLET],
  map[Paths.CONTACTS],
  map[Paths.DOCS],
];

export const settingsMenuRelation: TreeRelation<RouteItem> = [
  map[Paths.SETTINGS_NOTIFICATIONS],
  map[Paths.SETTINGS_GENERAL],
  map[Paths.SETTINGS_SECURITY],
  map[Paths.SETTINGS_PRIVACY],
  map[Paths.SETTINGS_SYNC_BACKUP],
  map[Paths.SETTINGS_DEVICES],
  map[Paths.SETTINGS_LANGUAGE],
  map[Paths.SETTINGS_ABOUT],
];

export const navMenu = genMenu(menuRelation);

export const settingsMenu = genMenu(settingsMenuRelation);
